import { Component, createRef } from 'react';
import {
  DataGrid,
  Column,
  Editing,
  Scrolling,
  Selection,
  SearchPanel,
  ColumnChooser,
  Grouping,
  GroupPanel,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  Search,
} from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import { Popup } from 'devextreme-react/popup';
import { LoadPanel } from 'devextreme-react/load-panel';

import { EditMemberForm } from '../../members/edit-member-form';
import { EditDesignationForm } from './edit-designation-form';
import { CurrentSwitch } from '~/components/current-switch/current-switch';
import { calcGridHeight } from '~/helpers/ui';
import {
  CreateAuthorizedStore,
  CreateAuthorizedDataSource,
  loadMembersLookupDataAsync,
  disposeMembersLookupData,
} from '~/helpers/data';
import { appConst } from '~/app-const';

import '../../pages.scss';

const designationsUrl = `${window.env.apiEndpoint}/api/v1/Designations`;
const membersUrl = `${window.env.apiEndpoint}/api/v1/Members`;

export class Designations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showEditForm: false,
      showMemberEditForm: false,
      showLoadingPanel: false,
      title: '',
    };

    this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
    this.toolbarItemRender = this.toolbarItemRender.bind(this);
    this.windowResized = this.windowResized.bind(this);
    this.editIconClick = this.editIconClick.bind(this);
    this.hideEditPopup = this.hideEditPopup.bind(this);
    this.refreshDesignationGrid = this.refreshDesignationGrid.bind(this);
    this.setShowMemberEditFormValue = this.setShowMemberEditFormValue.bind(this);
    this.hideMemberEditPopupAndRefreshGrid = this.hideMemberEditPopupAndRefreshGrid.bind(this);
    this.hideMemberEditPopup = this.hideMemberEditPopup.bind(this);
    this.showHideDesignationEditForm = this.showHideDesignationEditForm.bind(this);
    this.getMemberPopupRef = this.getMemberPopupRef.bind(this);

    this.dataSource = CreateAuthorizedDataSource(
      {
        loadUrl: `${designationsUrl}/Get`,
        insertUrl: `${designationsUrl}/Post`,
        updateUrl: `${designationsUrl}/Put`,
        deleteUrl: `${designationsUrl}/Delete`,
      },
      null, 'Id',
    );

    this.editDesignationFormRef = createRef();
    this.editMemberFormRef = createRef();

    this.editMemberFormPopupRef = createRef();
    this.designationsGridRef = createRef();
  }

  toolbarItemRender() {
    return (
      <CurrentSwitch grid={this.designationsGridRef} />
    );
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift(
      {
        template: 'switchCurrent',
        location: 'left',
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          onClick: () => {
            this.setState({
              showEditForm: true,
              rowData: {},
              addNewMode: true,
              title: '(New Designation)',
            });
          },
        },
      },
    );
  }

  async componentDidMount() {
    window.addEventListener('resize', this.windowResized);
    this.setState({ membersLookupData: await loadMembersLookupDataAsync() });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResized);
    if (this.dataSource && this.dataSource.isLoaded()) {
      this.dataSource.dispose();
    }

    const { membersLookupData } = this.state;

    membersLookupData && disposeMembersLookupData(membersLookupData);
  }

  windowResized() {
    this.designationsGridRef.current.instance().option('height', calcGridHeight('designationsGrid'));
  }

  editIconClick(key, name) {
    const getDesignationByIdStore = CreateAuthorizedStore(
      { loadUrl: `${designationsUrl}/GetDesignationById` }, { load: { Id: key } },
    );
    getDesignationByIdStore.load().then(
      (result) => {
        this.setState({
          showEditForm: true,
          title: name,
          rowData: { ...result[0] },
          addNewMode: false,
        });
      },
    );
  }

  hideEditPopup() {
    this.setState({
      rowData: {},
      showEditForm: false,
    });
  }

  refreshDesignationGrid() {
    this.designationsGrid.current.instance().refresh();
  }

  hideMemberEditPopup() {
    this.setState({
      showMemberEditForm: false,
    });
  }

  setShowMemberEditFormValue(value, memberkey) {
    this.setState({ showLoadingPanel: true });
    const getMemberByIdStore = CreateAuthorizedStore(
      { loadUrl: `${membersUrl}/GetMemberById` }, { load: { Id: memberkey } },
    );
    getMemberByIdStore.load().then(
      (result) => {
        this.setState({
          showMemberEditForm: value,
          rowMemberData: result[0],
          showLoadingPanel: false,
        });
      },
    );
  }

  hideMemberEditPopupAndRefreshGrid() {
    this.hideMemberEditPopup();
    this.editDesignationFormRef && this.editDesignationFormRef.current.refreshGrid();
  }

  getMemberPopupRef() {
    return this.editMemberFormPopupRef &&
      this.editMemberFormPopupRef.current
      && this.editMemberFormPopupRef.current.instance();
  }

  renderMemberEditPopUp(isEditFormShown) {
    const { rowMemberData } = this.state;
    if (isEditFormShown) {
      const { showMemberEditForm, membersLookupData } = this.state;
      return (
        <Popup
          ref={this.editMemberFormPopupRef}
          visible={showMemberEditForm}
          onHiding={(e) => {
            e.cancel = true;
            this?.editMemberFormRef?.current?.cancelData();
          }}
          {...appConst.defaultPopupOptions}
        >
          <EditMemberForm
            ref={this.editMemberFormRef}
            rowData={rowMemberData}
            hideEditPopupAndRefreshGrid={this.hideMemberEditPopupAndRefreshGrid}
            hideEditPopup={this.hideMemberEditPopup}
            salutationsData={membersLookupData.salutationsData}
            gendersData={membersLookupData.gendersData}
            pronounsData={membersLookupData.pronounsData}
            emailAddressTypesData={membersLookupData.emailAddressTypesData}
            phoneTypesData={membersLookupData.phoneTypesData}
            membershipTypesData={membersLookupData.membershipTypesData}
            employmentStatusesData={membersLookupData.employmentStatusesData}
            contractTypesData={membersLookupData.contractTypesData}
            designationsData={membersLookupData.designationsData}
            ridingsData={membersLookupData.ridingsData}
            addNewMode={false}
            getMemberPopupRef={this.getMemberPopupRef}
            provincesData={membersLookupData.provincesData}
          />
        </Popup>
      );
    }
  }

  showHideDesignationEditForm(value) {
    this.setState({
      showEditForm: value,
    });
  }

  render() {
    const {
      showEditForm,
      addNewMode, rowData, title, showMemberEditForm,
    } = this.state;
    return (
      <>
        <div className="title">
          <span>Designations</span>
        </div>
        <LoadPanel
          visible={this.state.showLoadingPanel}
          showIndicator
          shading
          showPane
          hideOnOutsideClick={false}
        />

        {showEditForm && (
          <>
            <Popup
              id="editDesignationPopup"
              visible
              onHiding={(e) => {
                e.cancel = true;
                this.editDesignationFormRef && this.editDesignationFormRef.current.cancelData();
              }}
              {...appConst.defaultPopupOptions}
              title={title}
            >
              <EditDesignationForm
                ref={this.editDesignationFormRef}
                addNewMode={addNewMode}
                rowData={rowData}
                setShowMemberEditFormValue={this.setShowMemberEditFormValue}
                showHideDesignationEditForm={this.showHideDesignationEditForm}
                refreshDesignationGrid={this.refreshDesignationGrid}
              />
            </Popup>
          </>
        )}

        {this.renderMemberEditPopUp(showMemberEditForm)}

        <DataGrid
          id="designationsGrid"
          ref={this.designationsGridRef}
          dataSource={this.dataSource}
          {...appConst.defaultGridOptions}
          onToolbarPreparing={this.onToolbarPreparing}
          onRowDblClick={(e) => {
            this.editIconClick(e.key, e.data.Description);
          }}
          onInitialized={(e) => {
            e.component.option('height', calcGridHeight(e.component.element().id));
          }}
        >
          <Selection mode="multiple" />
          <SearchPanel
            visible
            width={240}
            placeholder="Search..."
          />
          <Scrolling
            mode="virtual"
            rowRenderingMode="virtual"
          />
          <Editing
            mode="row"
            allowAdding={false}
            allowDeleting
            allowUpdating
          />
          <Column
            dataField="Description"
            dataType="string"
            sortOrder="asc"
            sortIndex="1"
          />
          <Column
            dataField="Current"
            filterValue
            dataType="boolean"
            sortOrder="desc"
            sortIndex="0"
          />
          <Column
            dataField="Common"
            dataType="boolean"
            sortOrder="desc"
            sortIndex="2"
          />
          <Column
            type="buttons"
            width={110}
            buttons={['delete', {
              hint: 'Edit',
              icon: 'edit',
              onClick: (e) => {
                this.editIconClick(e.row.key, e.row.data.Description);
              },
            }]}
          />
          <Template name="switchCurrent" render={this.toolbarItemRender} />
          <ColumnChooser
            enabled
            mode="dragAndDrop"
          />
          <Grouping
            allowCollapsing
            autoExpandAll={false}
            contextMenuEnabled
            expandMode="rowClick"
          />
          <GroupPanel
            visible
            allowColumnDragging
          />
          <HeaderFilter
            visible
          >
            <Search enabled={true}/>
          </HeaderFilter>
          <FilterRow visible />
          <FilterPanel visible />
        </DataGrid>
      </>
    );
  }
}
